class ScrollPositionAnalytics {

  constructor(analytics, window) {
    this.window = window
    this.analytics = analytics
    this.id = null
    this.stay_time_seconds = 0 
  }

  start() {
    if (this.id !== null) {
      throw Error('ScrollPositionAnalytics is already started.')
    }
    this.id = setInterval(() => {
      this.analytics.logEvent(
        'behavior_monitoring', {
          pageYOffset: this.window.pageYOffset,
          stayTimeSeconds: this.stay_time_seconds
        }
      )
      this.stay_time_seconds += 1
    }, 1000)
  }

  stop() {
    clearInterval(this.id)
    this.id = null
    this.stay_time_seconds = 0 
  }
}

export { ScrollPositionAnalytics }